/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingRuleAllocation extends models.BillingRule {
    constructor() {
        super();
        this.setDiscriminator("BillingRuleAllocation");
    }

    getFixupPrototypeFunction() { return BillingRuleAllocation.fixupPrototype; }

    static newInstance(model: Partial<BillingRuleAllocation>): BillingRuleAllocation {
        let obj = Object.assign(new BillingRuleAllocation(), model);
        BillingRuleAllocation.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingRuleAllocation>): BillingRuleAllocation {
        if (!model) return null;
        return BillingRuleAllocation.newInstance(<BillingRuleAllocation> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingRuleAllocation) {
        if (!obj) return;

        models.BillingRuleAllocation.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingRuleAllocation): boolean {
        if (models.BillingRule.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BillingRuleAllocation.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.execution_schedule) {
            models.BillingRuleRepeatingSchedule.fixupPrototype(this.execution_schedule);
        }
    }

    /**
     * Schedule for executing the automated rule
     */
    execution_schedule: models.BillingRuleRepeatingSchedule;

    /**
     * If True, requires admin approval before applying the rule
     */
    approval_required: boolean;

}
